import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, onSnapshot } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyARLYdd6A21O2apv29amT86QGRDXND1yUo",
    authDomain: "meeting-status-6bb0e.firebaseapp.com",
    projectId: "meeting-status-6bb0e",
    storageBucket: "meeting-status-6bb0e.firebasestorage.app",
    messagingSenderId: "195180872130",
    appId: "1:195180872130:web:559f77044bdb4cd4ca565b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, doc, setDoc, onSnapshot };
